"use client";
import { JotaiDevTools } from "@zapier/canvas/src/components/CanvasLayout/JotaiDevtools";
import { createStore, Provider } from "jotai";

export const store = createStore();

export function CanvasProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <JotaiDevTools store={store} />
      {children}
    </Provider>
  );
}
